import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import * as actions from '../../../action';
import * as c from '../../../constant';
import CoOwner from '../../../components/CoOwner';

function OwnerDetails({
  getMachineryOwnerList,
  ownerList,
  getSingleMachineryOwner,
  isLoadingGetSingleMachineryOwner,
  formData,
  setFormData,
  validateForm,
}) {
  const setModal = useContext(ModalContext);

  const ownerOptions = ownerList.map((x) => ({
    label: _.get(x, 'attributes.full_name'),
    value: x.id,
    id: x.id,
  }));

  const closeModal = (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to cancel adding this record? Changes won`t be saved.',
      () => {
        setModal({ isOpen: false });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleOnSelectMachineOwner = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });
    getSingleMachineryOwner(e.value, {}, ({ data }) => {
      setFormData({
        ...formData,
        [key]: e.value,
        machinery_owner_telephone_no: data.attributes.telephone_no,
        machinery_owner_tin: data.attributes.tin,
        machinery_owner_region_code: data.attributes.region_name,
        machinery_owner_province_code: data.attributes.province_name,
        machinery_owner_municipality_code: data.attributes.municipality_name,
        machinery_owner_barangay_code: data.attributes.barangay_name,
        machinery_owner_address_line: data.attributes.address_line,
      });
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnChangeCoOwners = (key) => (data) => {
    setFormData({
      ...formData,
      [key]: data,
    });
  };

  useEffect(() => {
    getMachineryOwnerList();
  }, []);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <>
      <div className="row">
        <div className="col-12 mb-2">
          <div className="header-modal">Owner Details</div>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="rptax_machinery_owner_id" className="form-label">
            Owner: &nbsp;{' '}
            {validateForm.renderMessage('rptax_machinery_owner_id')}
          </label>
          <div>
            <Select
              options={ownerOptions}
              placeholder="-Select-"
              value={
                ownerOptions.filter(
                  (item) =>
                    +_.get(formData, 'rptax_machinery_owner_id') ===
                    +_.get(item, 'id')
                ) || ''
              }
              onChange={handleOnSelectMachineOwner('rptax_machinery_owner_id')}
            />
          </div>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="machinery_owner_telephone_no" className="form-label">
            Telephone No.
          </label>
          <InputMask
            readOnly
            className="form-control"
            mask="99-9999-9999"
            alwaysShowMask
            type="text"
            name="machinery_owner_telephone_no"
            onChange={onChange}
            value={_.get(formData, 'machinery_owner_telephone_no') ?? ''}
          />
        </div>
        <div className="col-6 form-group">
          <label htmlFor="machinery_owner_tin" className="form-label mb-0">
            Tax Identification Number
          </label>
          <InputMask
            className="form-control"
            mask="999-999-999-999"
            readOnly
            type="text"
            name="machinery_owner_tin"
            onChange={onChange}
            value={_.get(formData, 'machinery_owner_tin') ?? ''}
          />
        </div>
        <div className="col-12 mt-2 mb-2">
          <div className="header-modal">Address</div>
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="machinery_owner_region_code"
            className="form-label mb-0"
          >
            Region
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="machinery_owner_region_code"
            onChange={onChange}
            value={_.get(formData, 'machinery_owner_region_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="machinery_owner_province_code"
            className="form-label mb-0"
          >
            Province
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="machinery_owner_province_code"
            onChange={onChange}
            value={_.get(formData, 'machinery_owner_province_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="machinery_owner_municipality_code"
            className="form-label mb-0"
          >
            Municipality
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="machinery_owner_municipality_code"
            onChange={onChange}
            value={_.get(formData, 'machinery_owner_municipality_code') || ''}
          />
        </div>
        <div className="col-6 form-group">
          <label
            htmlFor="machinery_owner_barangay_code"
            className="form-label mb-0"
          >
            Barangay
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="machinery_owner_barangay_code"
            onChange={onChange}
            value={_.get(formData, 'machinery_owner_barangay_code') || ''}
          />
        </div>
        <div className="col-12 form-group">
          <label
            htmlFor="machinery_owner_address_line"
            className="form-label mb-0"
          >
            Unit No. / House No. / Street Name
          </label>
          <input
            className="form-control text-uppercase"
            type="text"
            readOnly
            name="machinery_owner_address_line"
            onChange={onChange}
            value={_.get(formData, 'machinery_owner_address_line') || ''}
          />
        </div>
        <div className="col-12 form-group pt-2">
          <CoOwner
            value={formData.co_owners_ids || []}
            onChange={handleOnChangeCoOwners('co_owners_ids')}
            formData={formData}
            setFormData={setFormData}
            ownerList={ownerList}
          />
        </div>
      </div>
      <hr className="below-hr" />
      <div className="py-1">
        <div className="col-12 d-flex justify-content-center mt-3">
          <button
            type="button"
            onClick={closeModal}
            className="btn btn-light button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
            disabled={isLoadingGetSingleMachineryOwner}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
            disabled={
              !validateForm.response.is_passed ||
              isLoadingGetSingleMachineryOwner
            }
          >
            Proceed
          </button>
        </div>
      </div>
    </>
  );
}

OwnerDetails.defaultProps = {};

OwnerDetails.propTypes = {
  getMachineryOwnerList: PropTypes.instanceOf(Function).isRequired,
  ownerList: PropTypes.instanceOf(Array).isRequired,
  getSingleMachineryOwner: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  validateForm: PropTypes.instanceOf(Object).isRequired,
  isLoadingGetSingleMachineryOwner: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoadingGetSingleMachineryOwner:
    api.loading.indexOf(c.GET_SINGLE_MACHINERY_OWNER) > -1,
  ownerList: _.get(api, `${c.GET_MACHINERY_OWNER}.list`) || [],
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(OwnerDetails);
